import React, { Fragment,useState,useEffect } from 'react'
import { useParams } from 'react-router-dom';
import Footer from '../component/Footer'
import Header from '../component/Header'
import { apiwebUrl } from '../utils';

function Productodetalle() {
    const[itemget,setItemget] = useState([])
    let  params = useParams();
    
    const getItmes = (params) =>{
        const url = apiwebUrl+"productos.php?idproducto="+params.idproducto
        fetch(url)
        .then(response => response.json())
        .then(data => 
           {
            setItemget(data[0])
           }
        )
    }

    useEffect(() => {
        getItmes()
    }, [params])
    
    return (
        <Fragment>
            <Header />
                <div className='container-fluid mt-5'>
                    <section className='col-8 m-auto padded w__full' id='producto-detalle'>
                        <h3 className='fw-light letra__ text-center mb-5'>Producto: <span>{itemget.nombre}</span></h3>
                        <div className="row">
                                <div className="col-md w__full">
                                    {
                                        itemget.imagengrande === undefined?"":
                                        <img src={"https://servicios.campus.pe/" + itemget.imagengrande} alt={itemget.nombre} className="img-fluid" />
                                    }
                                   
                                </div>
                                <div className="col-md w__full">
                                    <table className='table'>
                                        <tbody>
                                            <tr><th>Detalle</th><td>{itemget.detalle}</td></tr>
                                            <tr><th>Precio</th><td>S/.
                                                {

                                                        itemget.preciorebajado === "0" ?
                                                        parseFloat(itemget.precio).toFixed(2) :
                                                        parseFloat(itemget.preciorebajado).toFixed(2)

                                                }
                                            </td></tr>
                                            <tr><th>Categoria</th><td>{itemget.categoria}</td></tr>
                                            <tr><th>Proveedor</th><td>{itemget.proveedor}</td></tr>
                                            <tr><th>Atencion al cliente</th><td>{itemget.telefono}</td></tr>
                                            <tr><th>Pais</th><td>{itemget.pais}</td></tr>
                                            <tr><th>Stock</th><td>{itemget.unidadesenexistencia}</td></tr>
                                        </tbody>
                                    </table>
                                    <div className='mb-3'>
                                        <button className='btn btn-primary'><i className="fa-solid fa-cart-shopping"></i> Añadir al carrito</button>
                                    </div>
                                    <h3>Descripcion</h3>
                                    <div dangerouslySetInnerHTML={{__html: itemget.descripcion}}></div>
                                </div>
                            </div>
                    </section>
                </div>
            <Footer />
        </Fragment>
    )
}

export default Productodetalle